import SearchIcons from '@/icons/SearchIcons'
import NotificationComp from '@/modules/Notification/components/Notification'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { ErrorBoundary, Typogaphy } from 'vnetwork-ui'
import Search from './Search'
import { useAppStore } from '@/stores/useAppStore'
import { useDashboardLayoutStore } from '@/stores/useDashboardLayoutStore'
import AccountDropdown from '@/components/AccountDropdown'
import AlertNotification from '@/components/AlertNotification'
import { Lock, Unlock, RotateCcw, Boxes } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/components/ui/tooltip'
import FestiveSwitch from '@/components/Festive/FestiveSwitch'

const Headers = () => {
    const location = useLocation()
    const { t } = useTranslation()
    const titleModule = location?.pathname?.split('/')?.[1] || 'dashboard'
    const { isShowHelp, sideBarFull } = useAppStore((state) => state)
    const {
        isLocked,
        toggleLock,
        resetLayout,
        storageKey,
        toggleStore,
        isStoreOpen,
        availableWidgetCount,
    } = useDashboardLayoutStore()

    // Check if we're on the dashboard page
    const isDashboardPage =
        location.pathname === '/' || location.pathname === ''

    return (
        <ErrorBoundary>
            <div
                id="main-header"
                className={`px-4 py-2 bg-white overflow-x-auto items-center justify-between flex lg:gap-10 gap-4 border-b border-gray-100 ${
                    sideBarFull
                        ? 'md:left-[241px] left-0'
                        : 'md:left-[58px] left-0'
                } ${isShowHelp ? 'mr-[500px] max-w-full' : ''}`}
            >
                <div className="flex items-center gap-3">
                    <Typogaphy
                        size="large"
                        className="font-semibold capitalize"
                        onClick={() => {
                            throw new Error('test sentry error')
                        }}
                    >
                        {t(titleModule)}
                    </Typogaphy>
                    {isDashboardPage && storageKey && (
                        <TooltipProvider>
                            <div className="flex items-center gap-1">
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <Button
                                            variant="ghost"
                                            size="icon"
                                            className="h-8 w-8"
                                            onClick={toggleLock}
                                            data-tour="dashboard-lock-button"
                                        >
                                            {isLocked ? (
                                                <Lock className="h-4 w-4 text-orange-500" />
                                            ) : (
                                                <Unlock className="h-4 w-4 text-gray-500" />
                                            )}
                                        </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        {isLocked
                                            ? t('dashboard.unlocked')
                                            : t('dashboard.locked')}
                                    </TooltipContent>
                                </Tooltip>
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <Button
                                            variant="ghost"
                                            size="icon"
                                            className="h-8 w-8"
                                            onClick={resetLayout}
                                        >
                                            <RotateCcw className="h-4 w-4 text-gray-500" />
                                        </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        {t('dashboard.reset-layout')}
                                    </TooltipContent>
                                </Tooltip>
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <Button
                                            variant="ghost"
                                            size="icon"
                                            className={`h-8 w-8 relative ${isStoreOpen ? 'bg-primary/10' : ''}`}
                                            onClick={toggleStore}
                                            data-tour="widget-store-button"
                                        >
                                            <Boxes
                                                className={`h-4 w-4 ${isStoreOpen ? 'text-primary' : 'text-gray-500'}`}
                                            />
                                            {availableWidgetCount > 0 && (
                                                <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 text-[10px] font-medium bg-primary text-white rounded-full flex items-center justify-center">
                                                    {availableWidgetCount}
                                                </span>
                                            )}
                                        </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        {t('dashboard.widget-store')}
                                    </TooltipContent>
                                </Tooltip>
                            </div>
                        </TooltipProvider>
                    )}
                </div>
                <Search />
                <div className="flex items-center gap-4">
                    <FestiveSwitch />
                    <SearchIcons className="text-bg-primary icon-small md:hidden block" />
                    <AlertNotification />
                    <NotificationComp />
                    <AccountDropdown />
                </div>
            </div>
        </ErrorBoundary>
    )
}

export default Headers
